export class OfficePhotoVM {
  id: any;
  name?: string;
  description?: string;
}